import App from './App.svelte';

const app = new App({
	target: document.body,
   hydrate: true, // Used by routing
//	props: {
//		port: 'Judaberg'
//	}
});

export default app;
